import { Box, Typography } from "@mui/material";
import { TalentCertificate } from "../../talents/talentAPI";
import { useTranslation } from "react-i18next";
import { CertificateValidTo } from "../talentCertificates/CertificateValidTo";
import { CustomButton } from "../../../common/components/functional/customButton/CustomButton";
import { ReactComponent as EditIcon } from "../../../common/icons/editGray.svg";
import DeleteButton from "../../../common/components/functional/formTable/DeleteButton";

type Props = {
  certificate: TalentCertificate;
  editMode: boolean;
  handleEdit: (certificate: TalentCertificate) => void;
  handleDelete: (certificate: TalentCertificate) => void;
};

export const PassportInformation = ({
  certificate,
  editMode,
  handleEdit,
  handleDelete,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="center" gap={4}>
      <CertificateValidTo certificate={certificate} />
      {editMode && (
        <>
          <CustomButton
            sx={{
              fontWeight: 400,
              textTransform: "none",
              padding: "4px",
            }}
            variant="text"
            startIcon={<EditIcon />}
            onClick={() => handleEdit(certificate)}
          >
            <Typography variant="secondary">{t("common:edit")}</Typography>
          </CustomButton>
          <DeleteButton
            handleDelete={() => handleDelete(certificate)}
            id={certificate.id}
          />
        </>
      )}
    </Box>
  );
};
